import { IColumnType } from "../../components/tableComponent/Table";

export const columns: IColumnType<any>[] = [
  {
    title: "ИД",
    dataIndex: "id",
    checkbox: true,
    menu: false,
    key: "0",
  },
  {
    title: "Дата",
    dataIndex: "created_at",
    type: "date",
    key: "1",
  },
  {
    title: "Отдел",
    type: "dropdown",
    dataIndex: "department",
    key: "2",
  },
  {
    title: "Страна 1",
    dataIndex: "country1",
    type: "string",
    key: "3",
  },
  {
    title: "Город 1",
    dataIndex: "city1",
    type: "string",
    width: 150,
    key: "4",
  },
  {
    title: "Страна 2",
    dataIndex: "country2",
    type: "string",
    key: "5",
  },
  {
    title: "Город 2",
    dataIndex: "city2",
    width: 150,
    type: "string",
    key: "6",
  },
  {
    title: "Кол-во КТК",
    dataIndex: "col_ktk",
    type: "range_integer",
    maxLength: 4,
    key: "7",
  },
  {
    title: "Тип КТК",
    dataIndex: "type_ktk",
    type: "dropdown",
    key: "8",
  },
  {
    title: "Качество",
    dataIndex: "quality",
    type: "dropdown",
    key: "9",
  },
  {
    title: "Ставка",
    dataIndex: "bet",
    type: "range_integer",
    maxLength: 15,
    key: "10",
  },
  {
    title: "Свободные дни",
    dataIndex: "free_days",
    type: "range_integer",
    maxLength: 4,
    key: "11",
  },
  {
    title: "СНП",
    dataIndex: "cnp",
    type: "range_integer",
    maxLength: 4,
    key: "12",
  },
  {
    title: "Комментарии",
    dataIndex: "comment",
    type: "string",
    width: 200,
    key: "13",
  },
  {
    title: "",
    dataIndex: "hidden",
    width: "20%",
    key: "14",
  },
];
